import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "coupons",
    object: "coupon",
    header: [
      { text: "Título", value: "title" },
      { text: "Descripción", value: "description" },
      { text: "Código", value: "code" },
      { text: "Tipo", value: "type" },
      { text: "Minutos gratis", value: "fee_minutes" },
      { text: "Usuarios", value: "user_coupons", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    roles: [],
    options: {
      sortBy: ["_id"],
      sortDesc: [false],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    create_bulk({ commit, state }, data) {
      let saveData = {};
      saveData[state.object] = data;
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .post(config.api_url + 'coupons_bulk', saveData)
          .then((response) => {
            commit("success");
            resolve(response.data);
          })
          .catch((error) => {
            commit("error");
            reject(error.response.data);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
